module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-16.ea5309c0.png";